import { ContentReference, IContent } from '@/@types/cms';

export const isContentType = (content: IContent, type: string) =>
  (content?.contentType?.slice(-1)[0] ?? '') === type;

export const isOfContentType = (content: IContent, matchingTypes: string[]) =>
  matchingTypes.includes(content?.contentType?.slice(-1)[0] ?? '');

/**
 * Returns a link (URL string) from a ContentReference object.
 */
export function getLinkFromContentReference(ref?: ContentReference): string | undefined {
  if (!ref) return undefined;

  // Handles both internal and external references
  if (ref.url) return ref.url;
}
